import { FaMapMarkerAlt, FaPhone, FaUserMd, FaUserInjured, FaEdit, FaTrash, FaEnvelope, FaCalendarAlt, FaClock, FaRegHospital } from "react-icons/fa";

const ClinicCard = ({ clinic, onEdit, onDelete }) => {
    // Count working days
    const workingDaysCount = clinic.workingDays?.filter(day => day.isWorking).length || 0;

    // Count availability hours
    const availabilityHours = clinic.workingDays?.reduce((total, day) => {
        return total + (day.availabilityHours?.length || 0);
    }, 0) || 0;
   
    return (
        <div className="rounded-lg border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 bg-white max-w-full">
            {/* Top accent bar */}
            <div className="h-1 sm:h-1.5 bg-primary" />
            
            <div className="p-3 sm:p-4 lg:p-5 space-y-3 sm:space-y-4">
                {/* Clinic Info */}
                <div className="space-y-2 sm:space-y-2.5">
                    <h3 className="text-base sm:text-lg lg:text-xl font-semibold text-gray-800 flex items-center gap-1.5 sm:gap-2 leading-tight">
                        <FaRegHospital className="text-sm sm:text-base lg:text-lg flex-shrink-0 text-primary" />
                        <span className="break-words min-w-0">{clinic.name}</span>
                    </h3>
                    
                    {/* Contact Information */}
                    <div className="space-y-1.5 sm:space-y-2">
                        <div className="flex items-start text-xs sm:text-sm text-gray-600 leading-relaxed">
                            <FaMapMarkerAlt className="mr-2 mt-0.5 flex-shrink-0 text-gray-500" />
                            <span className="break-words min-w-0 leading-relaxed">{clinic.address}</span>
                        </div>
                        
                        <div className="flex items-center text-xs sm:text-sm text-gray-600">
                            <FaPhone className="mr-2 flex-shrink-0 text-gray-500" />
                            <span className="font-medium">{clinic.phone}</span>
                        </div>
                        
                        <div className="flex items-start text-xs sm:text-sm text-gray-600">
                            <FaEnvelope className="mr-2 mt-0.5 flex-shrink-0 text-gray-500" />
                            <span className="break-all min-w-0">{clinic.email}</span>
                        </div>
                    </div>
                </div>

                {/* Stats Section */}
                <div className="bg-gray-50 rounded-lg p-2.5 sm:p-3">
                    <div className="flex flex-col xs:flex-row justify-between gap-2 xs:gap-4 text-xs sm:text-sm">
                        <div className="flex items-center text-gray-600">
                            <FaCalendarAlt className="mr-1.5 sm:mr-2 flex-shrink-0 text-green-600" />
                            <span className="font-medium">{workingDaysCount}</span>
                            <span className="ml-1 hidden xs:inline">working days</span>
                            <span className="ml-1 xs:hidden">days</span>
                        </div>
                        
                        <div className="flex items-center text-gray-600">
                            <FaClock className="mr-1.5 sm:mr-2 flex-shrink-0 text-blue-600" />
                            <span className="font-medium">{availabilityHours}</span>
                            <span className="ml-1 hidden xs:inline">time slots</span>
                            <span className="ml-1 xs:hidden">slots</span>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                {/* <div className="flex flex-col xs:flex-row gap-2 sm:gap-3 pt-2">
                    <button
                        disabled={!clinic.isOwned}
                        onClick={onEdit}
                        className={`
                            flex items-center justify-center gap-1.5 sm:gap-2 
                            px-3 sm:px-4 py-2 sm:py-2.5 
                            text-xs sm:text-sm font-medium
                            border border-blue-300 rounded-md sm:rounded-lg
                            transition-all duration-200
                            flex-1 xs:flex-none xs:min-w-0
                            ${clinic.isOwned 
                                ? "bg-blue-50 text-blue-700 hover:bg-blue-100 hover:border-blue-400 active:bg-blue-200" 
                                : "opacity-60 cursor-not-allowed bg-gray-100 text-gray-500 border-gray-200"
                            }
                        `}
                    >
                        <FaEdit className="flex-shrink-0" />
                        <span className="truncate">
                            {!clinic.isOwned ? (
                                <>
                                    <span className="hidden sm:inline">Edited by Center only</span>
                                    <span className="sm:hidden">Center only</span>
                                </>
                            ) : (
                                "Edit"
                            )}
                        </span>
                    </button>
                    
                    <button
                        disabled={!clinic.isOwned}
                        onClick={onDelete}
                        className={`
                            flex items-center justify-center gap-1.5 sm:gap-2 
                            px-3 sm:px-4 py-2 sm:py-2.5 
                            text-xs sm:text-sm font-medium
                            border border-red-300 rounded-md sm:rounded-lg
                            transition-all duration-200
                            flex-1 xs:flex-none xs:min-w-0
                            ${clinic.isOwned 
                                ? "bg-red-50 text-red-700 hover:bg-red-100 hover:border-red-400 active:bg-red-200" 
                                : "opacity-60 cursor-not-allowed bg-gray-100 text-gray-500 border-gray-200"
                            }
                        `}
                    >
                        <FaTrash className="flex-shrink-0" />
                        <span className="truncate">
                            {!clinic.isOwned ? (
                                <>
                                    <span className="hidden sm:inline">Deleted by Center only</span>
                                    <span className="sm:hidden">Center only</span>
                                </>
                            ) : (
                                "Delete"
                            )}
                        </span>
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default ClinicCard;